import type {AddRepresentativeCommissionFormPayload} from "./add-representative-commission.schema";

import {addRepresentativeCommission} from "@project/sdk/sales";
import {AddRepresentativeCommissionBody} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";

import {representativeKeys, representativeMutationKeys} from "../../../../../representative-keys";

export function addRepresentativeCommissionMutationOptions(representativeId: string) {
  return mutationOptions({
    mutationFn: (payload: AddRepresentativeCommissionFormPayload) => {
      const request = AddRepresentativeCommissionBody.parse(payload);

      return addRepresentativeCommission(representativeId, request);
    },
    mutationKey: representativeMutationKeys.addRepresentativeCommission,
    onSuccess: async (_result, _payload, _context, {client}) => {
      await client.invalidateQueries({queryKey: representativeKeys.detail(representativeId)});
    },
  });
}
